import { render, staticRenderFns } from "./VuesticDatePicker.vue?vue&type=template&id=06389601"
import script from "./VuesticDatePicker.vue?vue&type=script&lang=js"
export * from "./VuesticDatePicker.vue?vue&type=script&lang=js"
import style0 from "./VuesticDatePicker.vue?vue&type=style&index=0&id=06389601&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-date-picker/VuesticDatePicker.vue
// module id = S0Tt
// module chunks = 41